import "../../chunk-7QVYU63E.js";
import { ActivityType } from "@alch/protobufs-es/account_activity/account-activity_pb";
const ACCOUNT_ACTIVITY_TYPE_LABELS = {
  [ActivityType.UNKNOWN]: "Unknown",
  [ActivityType.APP_APP_CREATED]: "App created",
  [ActivityType.APP_APP_DELETED]: "App deleted",
  [ActivityType.APP_APP_NAME_UPDATED]: "App name updated",
  [ActivityType.APP_APP_DESCRIPTION_UPDATED]: "App description updated",
  [ActivityType.APP_JWT_CREATED]: "JWT created",
  [ActivityType.APP_JWT_DELETED]: "JWT deleted",
  [ActivityType.APP_ALLOWLIST_RESTRICTED_ADDRESS_ADDED]: "Allowlist restricted address added",
  [ActivityType.APP_ALLOWLIST_RESTRICTED_ADDRESS_REMOVED]: "Allowlist restricted address removed",
  [ActivityType.APP_ALLOWLIST_RESTRICTED_DOMAIN_ADDED]: "Allowlist restricted domain added",
  [ActivityType.APP_ALLOWLIST_RESTRICTED_DOMAIN_REMOVED]: "Allowlist restricted domain removed",
  [ActivityType.APP_ALLOWLIST_RESTRICTED_IP_ADDED]: "Allowlist restricted IP added",
  [ActivityType.APP_ALLOWLIST_RESTRICTED_IP_REMOVED]: "Allowlist restricted IP removed",
  [ActivityType.APP_NETWORK_ENABLED]: "Network enabled",
  [ActivityType.APP_NETWORK_DISABLED]: "Network disabled",
  [ActivityType.APP_NETWORK_ALL_ENABLED]: "All networks enabled",
  [ActivityType.APP_NETWORK_ALL_DISABLED]: "All networks disabled",
  [ActivityType.APP_API_KEY_ACCESS_UPDATED]: "API key access updated",
  [ActivityType.APP_ALERT_CREATED]: "Alert created",
  [ActivityType.APP_ALERT_UPDATED]: "Alert updated",
  [ActivityType.APP_ALERT_DELETED]: "Alert deleted",
  [ActivityType.APP_ALERT_ENABLED]: "Alert enabled",
  [ActivityType.APP_ALERT_DISABLED]: "Alert disabled",
  [ActivityType.APP_INITIALIZE_GAS_POLICY]: "Gas policy initialized",
  [ActivityType.APP_INITIALIZE_WALLET_CONFIG]: "Wallet config initialized",
  [ActivityType.APP_GAS_PUMP_PROGRAM_CREATED]: "Gas program created",
  [ActivityType.APP_GAS_PUMP_PROGRAM_UPDATED]: "Gas program updated",
  [ActivityType.APP_GAS_PUMP_PROGRAM_DELETED]: "Gas program deleted",
  [ActivityType.APP_GAS_PUMP_PROGRAM_BUILDER_APPROVED]: "Gas program builder approved",
  [ActivityType.APP_GAS_PUMP_PROGRAM_BUILDER_REJECTED]: "Gas program builder rejected",
  [ActivityType.APP_GAS_POLICY_CREATED]: "Gas policy created",
  [ActivityType.APP_GAS_POLICY_UPDATED]: "Gas policy updated",
  [ActivityType.APP_GAS_POLICY_DELETED]: "Gas policy deleted",
  [ActivityType.APP_GAS_POLICY_ACTIVATED]: "Gas policy activated",
  [ActivityType.APP_GAS_POLICY_DEACTIVATED]: "Gas policy deactivated",
  [ActivityType.APP_APP_KEY_ROTATED]: "API key rotated",
  [ActivityType.ACCOUNT_TEAM_NAME_UPDATED]: "Team name updated",
  [ActivityType.ACCOUNT_TEAM_USER_ADDED]: "User invited to team",
  [ActivityType.ACCOUNT_TEAM_USER_INVITE_SENT]: "User invited to team",
  [ActivityType.ACCOUNT_TEAM_USER_INVITE_ACCEPTED]: "User accepted team invite",
  [ActivityType.ACCOUNT_TEAM_USER_REMOVED]: "User removed from team",
  [ActivityType.ACCOUNT_TEAM_USER_ROLE_UPDATED]: "User role updated",
  [ActivityType.ACCOUNT_ACCESS_KEY_CREATED]: "Access key created",
  [ActivityType.ACCOUNT_ACCESS_KEY_DELETED]: "Access key deleted",
  [ActivityType.ACCOUNT_TEAM_ONBOARDING_NETWORK_UPDATED]: "Onboarding network updated",
  [ActivityType.ACCOUNT_TEAM_USER_DETAILS_UPDATED]: "User details updated",
  [ActivityType.ACCOUNT_TEAM_IP_ALLOWLIST_IP_ADDED]: "IP allowlist address added",
  [ActivityType.ACCOUNT_TEAM_IP_ALLOWLIST_IP_REMOVED]: "IP allowlist address removed",
  [ActivityType.ACCOUNT_TEAM_IP_ALLOWLIST_IP_UPDATED]: "IP allowlist address updated",
  [ActivityType.BILLING_PLAN_UPDATED]: "Billing plan updated",
  [ActivityType.BILLING_PLAN_SPEND_LIMIT_UPDATED]: "Spend limit updated",
  [ActivityType.BILLING_USAGE_LIMIT_UPDATED]: "Usage limit updated",
  [ActivityType.BILLING_USAGE_LIMIT_BY_APP_UPDATED]: "App usage limit updated",
  [ActivityType.BILLING_PAYMENT_METHOD_UPDATED]: "Payment method updated",
  [ActivityType.BILLING_PAYMENT_METHOD_ADDED]: "Payment method added",
  [ActivityType.BILLING_PAYMENT_METHOD_REMOVED]: "Payment method removed",
  [ActivityType.BILLING_INVOICE_EMAIL_UPDATED]: "Invoice email updated",
  [ActivityType.BILLING_INVOICE_EMAIL_ADDED]: "Invoice email added",
  [ActivityType.BILLING_INVOICE_EMAIL_REMOVED]: "Invoice email removed",
  [ActivityType.BILLING_PAYMENT_ADDRESS_UPDATED]: "Payment address updated",
  [ActivityType.BILLING_TAX_DETAILS_UPDATED]: "Tax details updated",
  [ActivityType.BILLING_APP_USAGE_CAP_CREATED]: "Usage cap created",
  [ActivityType.BILLING_APP_USAGE_CAP_UPDATED]: "Usage cap updated",
  [ActivityType.BILLING_APP_USAGE_CAP_DELETED]: "Usage cap deleted",
  [ActivityType.BILLING_USAGE_AUTOSCALE_ENABLED]: "Autoscale enabled",
  [ActivityType.BILLING_USAGE_AUTOSCALE_DISABLED]: "Autoscale disabled",
  [ActivityType.AUTH_LOGIN_SUCCESS]: "Login success",
  [ActivityType.AUTH_LOGIN_FAILED]: "Login failed",
  [ActivityType.AUTH_PASSWORD_RESET_REQUESTED]: "Password reset requested",
  [ActivityType.AUTH_PASSWORD_RESET_COMPLETED]: "Password reset completed",
  [ActivityType.WALLET_SESSION_CREATED]: "Wallet session created",
  [ActivityType.WALLET_SESSION_DISCONNECTED]: "Wallet session disconnected",
  [ActivityType.WALLET_SESSION_APPROVED]: "Wallet session approved",
  [ActivityType.WALLET_SESSION_DENIED]: "Wallet session denied",
  [ActivityType.WALLET_SESSION_REVOKED]: "Wallet session revoked",
  [ActivityType.WALLET_SYNCED]: "Wallet synced",
  [ActivityType.WALLET_SIGNATURE_REQUESTED]: "Wallet signature requested",
  [ActivityType.WALLET_SIGNATURE_COMPLETED]: "Wallet signature completed",
  [ActivityType.WALLET_SIGNATURE_REJECTED]: "Wallet signature rejected",
  [ActivityType.WALLET_KEY_QUORUM_CREATED]: "Wallet key quorum created",
  [ActivityType.WALLET_KEY_QUORUM_UPDATED]: "Wallet key quorum updated",
  [ActivityType.WALLET_KEY_QUORUM_DELETED]: "Wallet key quorum deleted"
};
export {
  ACCOUNT_ACTIVITY_TYPE_LABELS
};
//# sourceMappingURL=accountActivities.js.map